export const createLinkWithPath = (link) => {
    const { origin, pathname } = window.location;

    const pathSegments = pathname.split("/").filter(Boolean);
    if (pathSegments.length > 1) pathSegments.pop();
    const basePath = pathSegments.length ? `/${pathSegments.join("/")}` : "";
    return `${origin}${basePath}/${link}`;
};

createLinkWithPath("textures");
